/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Tab_ChecklistInputs */

const en_directory_agent_readiness_tab_checklist = /** @type {(inputs: Directory_Agent_Readiness_Tab_ChecklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checklist`)
};

const zh_directory_agent_readiness_tab_checklist = /** @type {(inputs: Directory_Agent_Readiness_Tab_ChecklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查清单`)
};

/**
* | output |
* | --- |
* | "Checklist" |
*
* @param {Directory_Agent_Readiness_Tab_ChecklistInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_tab_checklist = /** @type {((inputs?: Directory_Agent_Readiness_Tab_ChecklistInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Tab_ChecklistInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_tab_checklist(inputs)
	return zh_directory_agent_readiness_tab_checklist(inputs)
});
export { directory_agent_readiness_tab_checklist as "directory.agent_readiness.tab.checklist" }